var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.1,225.9v12.3h-67.6v-12.3l10.9-2.4c0.2-11.9,0.2-26.2,0.2-36.1v-12.1c0-13.3-0.2-20.8-0.7-30.5 l-13.1-2.2v-9.9l56.2-16.7l4.4,2.7l-0.7,36.1v32.7c0,10.2,0,24.7,0.2,36.3L185.1,225.9z M128.9,81.3c0-12.1,9.9-20.8,22.3-20.8 c12.4,0,22.3,8.7,22.3,20.8c0,12.1-9.9,20.8-22.3,20.8C138.9,102.2,128.9,93.4,128.9,81.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,295C70,295,5,230,5,150S70,5,150,5c80,0,145,65,145,145S230,295,150,295z M150,27.4 c-67.6,0-122.6,55-122.6,122.6s55,122.6,122.6,122.6c67.6,0,122.6-55,122.6-122.6S217.6,27.4,150,27.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.29c1b1bd8c838e098812a31d103312f7.svg";
export { ForwardRef as ReactComponent };